import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { stateType } from '../types/types';

export const useTheme = () => {
  const theme = useSelector((state: stateType) => state.app.app.theme);

  return {
    isDark: theme === 'dark',
  };
};

// Mirrors Redux theme onto #root so CSS like [data-theme='dark'] matches patient flows (e.g. calibration card assets).
export const useRootDataThemeSync = () => {
  const theme = useSelector((state: stateType) => state.app.app.theme);

  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;
    if (theme === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }
  }, [theme]);
};
